import { ScreenInfo } from './ScreenInfoContext';
import {
  ActionType,
  UPDATE_SCREEN_INFO,
  UPDATE_SCREEN_NAME,
  UPDATE_SCREEN_DATE,
  UPDATE_SCREEN_LOCATION,
  UPDATE_SCREEN_DESCRIPTION,
} from './actions';

export function screenInfoReducer(
  state: ScreenInfo,
  action: ActionType,
): ScreenInfo {
  switch (action.type) {
    case UPDATE_SCREEN_INFO: {
      return {
        ...state,
        name: action.payload.name ?? state.name,
        date: action.payload.date ?? state.date,
        location: action.payload.location ?? state.location,
        description: action.payload.description ?? state.description,
      };
    }

    case UPDATE_SCREEN_NAME: {
      return {
        ...state,
        name: action.payload.name,
      };
    }

    case UPDATE_SCREEN_DATE: {
      return {
        ...state,
        date: action.payload.date,
      };
    }

    case UPDATE_SCREEN_LOCATION: {
      return {
        ...state,
        location: action.payload.location,
      };
    }

    case UPDATE_SCREEN_DESCRIPTION: {
      return {
        ...state,
        description: action.payload.description,
      };
    }

    default:
      return state;
  }
}
